/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Order status as persisted by the canonical orders table and returned on the public order API.  This is intentionally separate from the broader engine state enum: only statuses representable in PostgreSQL may appear in a durable order response.
 */
export enum OrderResponseStatus {

    New = 'new',

    PartiallyFilled = 'partially_filled',

    Filled = 'filled',

    Cancelled = 'cancelled',

    Rejected = 'rejected',

    Expired = 'expired'
}
